/**
 * TODO Mobile App
 *
 * @format
 */

import React from 'react';
import { Platform, StatusBar, useColorScheme, View } from 'react-native';
import { SafeAreaProvider } from 'react-native-safe-area-context';
import { TamaguiProvider, Theme } from '@tamagui/core';
import { PortalProvider } from '@tamagui/portal'
import './src/locales';
import AppNavigator from './src/navigation/AppNavigator';
import { ThemeProvider, useThemeContext } from './src/contexts/ThemeContext';
import { AuthProvider } from './src/contexts/AuthContext';
import { ApplicationNotificationsProvider } from './src/contexts/ApplicationNotificationsContext';
import { ActiveChatProvider } from './src/contexts/ActiveChatContext';
import { ToastProvider } from './src/providers/ToastProvider';
import { AppShell } from './src/components/AppShell';
import config from './tamagui.config';
import { queryClient } from '@/api/queryClient';
import { QueryProvider } from './src/providers/QueryProvider';

// Web-compatible SafeAreaProvider wrapper
const SafeAreaWrapper: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  if (Platform.OS === 'web') {
    // On web, just render children without SafeAreaProvider
    return <>{children}</>;
  }
  return <SafeAreaProvider>{children}</SafeAreaProvider>;
};


function AppContent(): React.JSX.Element {
  const { isDark, isLoading } = useThemeContext();

  // Show loading while theme loads
  if (isLoading) {
    return (
      <Theme name="light">
        {Platform.OS !== 'web' && <StatusBar barStyle="dark-content" />}
        <AppShell>
          <AppNavigator />
        </AppShell>
      </Theme>
    );
  }

  return (
    <Theme name={isDark ? 'dark' : 'light'}>
      {Platform.OS !== 'web' && <StatusBar barStyle={isDark ? 'light-content' : 'dark-content'} />}
      <AppShell>
        <AppNavigator />
      </AppShell>
    </Theme>
  );
}

function App(): React.JSX.Element {
  // Always start with light theme by default
  const initialDarkMode = false;

  return (
    <QueryProvider>
      <TamaguiProvider config={config}>
        <PortalProvider>
          <SafeAreaWrapper>
            <ThemeProvider initialTheme={initialDarkMode}>
              <AuthProvider>
                <ActiveChatProvider>
                  <ApplicationNotificationsProvider>
                    <ToastProvider>
                      <AppContent />
                    </ToastProvider>
                  </ApplicationNotificationsProvider>
                </ActiveChatProvider>
              </AuthProvider>
            </ThemeProvider>
          </SafeAreaWrapper>
        </PortalProvider>
      </TamaguiProvider>
    </QueryProvider>
  );
}

export default App;
